var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "date-window modal-card" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [_vm._v(" Profile Date ")]),
      !_vm.asOfError
        ? _c(
            "a",
            {
              staticClass: "close-modal",
              attrs: { "aria-label": "close" },
              on: {
                click: function ($event) {
                  return _vm.closeModal()
                },
              },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
          )
        : _vm._e(),
    ]),
    _vm.asOfError
      ? _c("section", { staticClass: "as-of-error-section" }, [
          _c("div", { staticClass: "as-of-alert-error" }, [
            _vm._v(
              "The date specified in your profile is no longer valid. Please select a new date to continue, or click cancel to abort the loading of the profile."
            ),
          ]),
        ])
      : _vm._e(),
    _c("section", [
      _c(
        "div",
        {
          staticClass: "left-side",
          class: { focused: _vm.focusedSide === _vm.FocusedSide.Left },
          on: {
            click: function ($event) {
              _vm.focusedSide = _vm.FocusedSide.Left
            },
          },
        },
        [
          _c("h5", [_vm._v("Choose a specific date")]),
          _c(
            "div",
            { staticClass: "calendar-container" },
            [
              _c("v-date-picker", {
                ref: "calendar",
                attrs: {
                  "is-inline": true,
                  mode: "single",
                  "from-page": _vm.manualMonthToShow,
                  "max-date": _vm.maxDate,
                  "min-date": _vm.minDate,
                },
                on: {
                  input: function ($event) {
                    return _vm.datePickerUpdated($event)
                  },
                },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "right-side",
          class: { focused: _vm.focusedSide === _vm.FocusedSide.Right },
        },
        [
          _c(
            "div",
            {
              staticClass: "input-area",
              on: {
                click: function ($event) {
                  _vm.focusedSide = _vm.FocusedSide.Right
                },
              },
            },
            [
              _c("h5", [_vm._v("Choose a relative date(?)")]),
              _c("div", { staticClass: "input-row" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.offset,
                      expression: "offset",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "input",
                  attrs: { min: "0", step: "1", type: "number" },
                  domProps: { value: _vm.offset },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.offset = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.offsetUnit,
                          expression: "offsetUnit",
                        },
                      ],
                      staticClass: "select",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.offsetUnit = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.offsetUnitList, function (unit) {
                      return _c(
                        "option",
                        { key: unit, domProps: { value: unit } },
                        [_vm._v(_vm._s(unit))]
                      )
                    }),
                    0
                  ),
                ]),
                _c("div", { staticClass: "postfix" }, [
                  _c("span", { class: { hidden: _vm.offset === 1 } }, [
                    _vm._v("s"),
                  ]),
                  _vm._v(" ago"),
                ]),
              ]),
              _vm.relativeValueError &&
              _vm.focusedSide === _vm.FocusedSide.Right
                ? _c("span", { staticClass: "error-text" }, [
                    _vm._v(" " + _vm._s(_vm.relativeValueError) + " "),
                  ])
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "button-area" }, [
            _c(
              "button",
              {
                staticClass:
                  "button button-secondary button-outline button-medium",
                on: {
                  click: function ($event) {
                    return _vm.cancel()
                  },
                },
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "button",
              {
                staticClass: "button button-primary button-medium save-button",
                attrs: {
                  disabled:
                    (_vm.relativeValueError &&
                      _vm.focusedSide === _vm.FocusedSide.Right) ||
                    (!_vm.date && _vm.focusedSide === _vm.FocusedSide.Left),
                },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v(" Apply ")]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }